import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";
import { HelmetProvider } from "react-helmet-async";
import { LanguageProvider } from "@/i18n/LanguageContext";
import HomePage from "@/pages/HomePage";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsOfService from "@/pages/TermsOfService";
import Imprint from "@/pages/Imprint";
import ConnectivityPage from "@/pages/ConnectivityPage";
import TektelicPage from "@/pages/TektelicPage";
import IoTForCitiesPage from "@/pages/IoTForCitiesPage";
import ToolTrackingPage from "@/pages/ToolTrackingPage";
import AssetTrackingPage from "@/pages/AssetTrackingPage";
import IndoorAirQualityPage from "@/pages/IndoorAirQualityPage";
import SmartMeteringPage from "@/pages/SmartMeteringPage";
import SmartCityInfrastructurePage from "@/pages/SmartCityInfrastructurePage";
import SmartLockersPage from "@/pages/SmartLockersPage";
import BuildingEnergyEfficiencyPage from "@/pages/BuildingEnergyEfficiencyPage";
import OfficeSpaceManagementPage from "@/pages/OfficeSpaceManagementPage";
import RealEstatePage from "@/pages/RealEstatePage";
import E2InsurancePage from "@/pages/E2InsurancePage";
import QdApp from "@/quote/QdApp";
import BlogPage from "@/pages/BlogPage";
import BlogArticlePage from "@/pages/BlogArticlePage";

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
}

function App() {
  return (
    <HelmetProvider>
      <LanguageProvider>
        <div className="App">
          <BrowserRouter>
            <ScrollToTop />
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/connectivity" element={<ConnectivityPage />} />
              <Route path="/tektelic" element={<TektelicPage />} />
              <Route path="/iot-for-cities" element={<IoTForCitiesPage />} />
              <Route path="/tool-tracking" element={<ToolTrackingPage />} />
              <Route path="/asset-tracking" element={<AssetTrackingPage />} />
              <Route path="/indoor-air-quality-monitoring" element={<IndoorAirQualityPage />} />
              <Route path="/smart-metering" element={<SmartMeteringPage />} />
              <Route path="/smart-city-iot-infrastructure" element={<SmartCityInfrastructurePage />} />
              <Route path="/smart-lockers" element={<SmartLockersPage />} />
              <Route path="/building-energy-efficiency" element={<BuildingEnergyEfficiencyPage />} />
              <Route path="/office-space-management" element={<OfficeSpaceManagementPage />} />
              <Route path="/real-estate" element={<RealEstatePage />} />
              <Route path="/real-estate.html" element={<RealEstatePage />} />
              <Route path="/e2-insurance" element={<E2InsurancePage />} />
              <Route path="/quote/*" element={<QdApp />} />
              <Route path="/BalticHub2026" element={<Navigate to="/" replace />} />
              <Route path="/baltichub2026" element={<Navigate to="/" replace />} />
              <Route path="/baltics-hub-2026" element={<Navigate to="/" replace />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/blog/:slug" element={<BlogArticlePage />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms" element={<TermsOfService />} />
              <Route path="/imprint" element={<Imprint />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-right" />
        </div>
      </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;
